/* eslint-disable max-len */
import axios from 'axios';
// import axiosConfig from './axiosConfig';

import {
  DOWNLOAD_GEODE_SYML_FILE,
  DOWNLOAD_SITE_LOG_FILE,
  FETCH_CALENDAR_DATA,
  FETCH_FILES_DATA,
  FETCH_FULL_ONE_STATION_DATA,
  FETCH_FULL_SELECTED_STATION_DATA,
  FETCH_QUALITY_DATA,
  FETCH_STATIONS,
  saveFullOneStationData,
  saveStations,
} from '../actions/dataAPI';
import {
  DisplayDOI,
  DisplayImages,
  SET_FETCH_DOI_AND_LICENCE,
  SET_FETCH_IMAGES,
  SaveDoiAndLicence,
  SaveImages,
  saveCalendarData,
  saveQualityData,
  setFetchData,
  setFullDataAvailable,
  setLoadingFullData,
  setResponseImage,
  setSaveFullOneStationData,
} from '../actions/metadata';
import {
  FETCH_ALL_PAGES,
  FETCH_ANTENNA_LIST,
  FETCH_BACKEND_POPUP,
  FETCH_FILE_TYPE_LIST,
  FETCH_RADOME_LIST,
  FETCH_RECEIVER_LIST,
  saveAntennaList,
  saveBackendPopup,
  saveFileTypeList,
  savePagesList,
  saveRadomeList,
  saveReceiverList,
  setDataAvailable,
  setLoadingChart,
  setLoadingMap,
  setMapResults,
} from '../actions/site';
import {
  FETCH_ADVANCED_SEARCH,
  setErrorCode,
  setErrorStatus,
  setModalErrCo,
  setModalNoData,
  setSaveFullDataSelectedStations,
} from '../actions/multipleMetadata';
import {
  FETCH_COMBINATION_FILES,
  FETCH_FILES_DATA_PAGINATION,
  launchDataPagination,
  saveFilesData,
  saveFilesDataPagination,
  setValueDisplayLoading,
} from '../actions/file';
import { FETCH_NETWORK_FULL_DATA, saveNetworkFullData } from '../actions/network';
import {
  FETCH_NODE_INFO_MAP_PAGE,
  FETCH_NODE_INFO_TAB_PAGE,
  setLoadingNodeInfoMap,
  setLoadingNodeInfoTab,
  setSaveMapNodeInfoPage,
  setSaveTabNodeInfoPage,
} from '../actions/nodeInfo';
import { FETCH_HEADER, setLoadingHeader, setSaveDataHeader } from '../actions/header';
import { FETCH_FOOTER, setLoadingFooter, setSaveDataFooter } from '../actions/footer';
import { FETCH_PERSONALIZED_PAGE_HTML, savePersonalizedPageHtml, setLoadingPersonalized } from '../actions/personalized';

const DGWAPI = process.env.REACT_APP_DGW_BACKEND_API;
const axiosInstanceDGWAPI = axios.create({
  baseURL: DGWAPI,
});

let personalized = false;

const apiMiddleWare = (store) => (next) => (action) => {
  switch (action.type) {
    case FETCH_STATIONS: {
      store.dispatch(setLoadingMap(true));
      axios
        .get(`${action.value1}${action.value2}/webresources/stations/v2/combination/short/json/`)
        .then(
          (response) => {
            store.dispatch(saveStations(response));
            store.dispatch(setDataAvailable(true));
            store.dispatch(setFullDataAvailable(true));
            if (response.status === 200) {
              store.dispatch(setMapResults(true));
            }
          },
        ).catch((e) => {
          console.log('No response from the API', e);
          store.dispatch(setDataAvailable(false));
          store.dispatch(setFullDataAvailable(false));
        }).finally(() => {
          store.dispatch(setLoadingMap(false));
        });
      next(action);
      break;
    }
    case FETCH_FULL_ONE_STATION_DATA: {
      store.dispatch(setLoadingFullData(true));
      axios
        .get(`${action.server}${action.glassapi}/webresources/stations/v2/combination/full/json?marker=${action.query}`)
        .then(
          (response) => {
            store.dispatch(setSaveFullOneStationData(false));
            store.dispatch(saveFullOneStationData(response.data));
            store.dispatch(setLoadingFullData(true));
            if (response.status === 200) {
              store.dispatch(setLoadingFullData(false));
            }
          },
        ).catch(() => {
          store.dispatch(setLoadingFullData(true));
          store.dispatch(setFullDataAvailable(false));
          console.log('No response from the API');
        }).finally(() => {
        });
      next(action);
      break;
    }
    case FETCH_FULL_SELECTED_STATION_DATA: {
      axios
        .get(`${action.server}${action.glassapi}/webresources/stations/v2/combination/full/json?${action.query}`)
        .then(
          (response) => {
            if (response.data.length === 0) {
              store.dispatch(setModalNoData(true));
            }
            else {
              store.dispatch(setSaveFullDataSelectedStations(response.data));
            }
          },
        ).catch(() => {
          console.log(`No response from the API: ${action.server}${action.glassapi}/webresources/stations/v2/combination/full/json?${action.query}`);
        }).finally(() => {
        });
      next(action);
      break;
    }
    case DOWNLOAD_GEODE_SYML_FILE: {
      axios
        .get(`${action.server}${action.glassapi}/webresources/log/geodesyml/${action.marker}`)
        .then(
          () => {
            const url = `https://gnssdata-epos.oca.eu/GlassFramework/webresources/log/geodesyml/${action.marker}`;
            const link = document.createElement('a');
            link.href = url;
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
          },
        )
        .catch(() => {
          console.log(`No response from the API: https://gnssdata-epos.oca.eu/GlassFramework/webresources/log/geodesyml/${action.marker}`);
        })
        .finally(() => {
        });
      next(action);
      break;
    }
    case DOWNLOAD_SITE_LOG_FILE: {
      axios
        .get(`${action.server}${action.glassapi}/webresources/log/${action.marker}`)
        .then(() => {
          const url = `https://gnssdata-epos.oca.eu/GlassFramework/webresources/log/${action.marker}`;
          const link = document.createElement('a');
          link.href = url;
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        })
        .catch(() => {
          console.log(' No response from the API');
        });
      next(action);
      break;
    }
    case FETCH_CALENDAR_DATA: {
      axios
        .get(`${action.server}${action.glassapi}/webresources/files/combination/${action.query}/json`)
        .then((data) => store.dispatch(saveCalendarData(data.data)))
        .catch(() => {
          console.log(`No response from the API for get : /webresources/files/combination/${action.query}/json`);
        })
        .finally(() => {
          store.dispatch(setFetchData(true));
        });
      next(action);
      break;
    }
    case FETCH_QUALITY_DATA: {
      axios
        .get(`${action.server}${action.glassapi}/webresources/files/combinationT3/marker=${action.marker}&dateRange=${action.dateFrom}|${action.dateTo}/json`)
        .then((data) => store.dispatch(saveQualityData(data.data)))
        .catch(() => {
          console.log(`No response from the API for get to : /webressources/files/combinationT3/marker=${action.marker}&dateRange=${action.dateFrom}|${action.dateTo}/json`);
        });
      next(action);
      break;
    }
    case FETCH_FILES_DATA: {
      axios
        .get(`${action.server}${action.glassapi}/webresources/files/combination/marker=${action.query}/json`)
        .then((data) => store.dispatch(saveFilesData(data.data)))
        .catch((error) => {
          if (error.code !== '' || error.code !== undefined) {
            store.dispatch(setModalErrCo(true));
            store.dispatch(setErrorCode(error.code));
            store.dispatch(setErrorStatus(error.request.status));
          }
          console.log(`No response from the API for get to : /webressources/files/combination/marker=${action.query}/json`);
        });
      next(action);
      break;
    }
    case FETCH_FILES_DATA_PAGINATION: {
      axios
        .get(`${action.server}${action.glassapi}/webresources/files/combination/${action.query}/json/${action.page}/${action.number}`)
        .then((data) => {
          // console.log(`${action.server}${action.glassapi}/webresources/files/combination/${action.query}/json/${action.page}/${action.number}`);
          if (data.data.length > 0) {
            store.dispatch(launchDataPagination(true));
            store.dispatch(saveFilesDataPagination(data.data));
            if (action.page === 1) {
              store.dispatch(setLoadingMap(false));
            }
          }
          else if (data.data.length === 0 && action.page === 1) {
            store.dispatch(setModalNoData(true));
          }
          else if (data.data.length === 0 && action.page > 1) {
            setTimeout(() => {
              store.dispatch(setValueDisplayLoading(false));
            }, 2000);
          }
        })
        .catch((error) => {
          if (error.code !== '' || error.code !== undefined) {
            store.dispatch(setModalErrCo(true));
            store.dispatch(setErrorCode(error.code));
            store.dispatch(setErrorStatus(error.request.status));
          }
          console.log(`No response from the API for get to : ${action.server}${action.glassapi}/webresources/files/combination/${action.query}/json/${action.page}/${action.number}`);
        });
      next(action);
      break;
    }
    case FETCH_COMBINATION_FILES: {
      axios
        .get(`${action.server}${action.glassapi}/webresources/files/combination/${action.query}/json`, {
          validateStatus: function (status) {
            return status >= 200 && status < 500;
          },
        })
        .then((data) => store.dispatch(saveFilesData(data.data)))
        .catch((error) => {
          // store.dispatch(setModalNoData(true));
          // setTimeout(() => {
          //   store.dispatch(setModalNoData(false));
          //   // window.location.replace(window.origin);
          //   window.close();
          // }, 7000);
          if (error.code !== '' || error.code !== undefined) {
            store.dispatch(setModalErrCo(true));
            store.dispatch(setErrorCode(error.code));
            store.dispatch(setErrorStatus(error.request.status));
          }
          console.log(`No response from the API for get to : /webressources/files/combination/marker=${action.query}/json`);
          return Promise.reject(error);
        });
      next(action);
      break;
    }
    case FETCH_NETWORK_FULL_DATA: {
      axios
        .get(`${action.server}${action.glassapi}/webresources/stations/v2/combination/full/json?network=${action.query}`)
        .then((response) => store.dispatch(saveNetworkFullData(response.data)));
      next(action);
      break;
    }
    case FETCH_RECEIVER_LIST: {
      axios
        .get(`${action.server}${action.glassapi}/webresources/stations/v2/list/receiver`)
        .then((response) => {
          const receiverList = [];
          response.data.forEach((el) => {
            receiverList.push(el.name);
          });
          receiverList.sort();
          store.dispatch(saveReceiverList(receiverList));
        });
      next(action);
      break;
    }
    case FETCH_ANTENNA_LIST: {
      axios
        .get(`${action.server}${action.glassapi}/webresources/stations/v2/list/antenna`)
        .then(
          (response) => {
            const antennaList = [];
            response.data.forEach((el) => {
              antennaList.push(el.name);
            });
            antennaList.sort();
            store.dispatch(saveAntennaList(antennaList));
          },
        );
      next(action);
      break;
    }
    case FETCH_RADOME_LIST: {
      axios
        .get(`${action.server}${action.glassapi}/webresources/stations/v2/list/radome`)
        .then(
          (response) => {
            const radomeList = [];
            response.data.forEach((el) => {
              radomeList.push(el.name);
            });
            radomeList.sort();
            store.dispatch(saveRadomeList(radomeList));
          },
        );
      next(action);
      break;
    }
    case FETCH_FILE_TYPE_LIST: {
      axios
        .get(`${action.server}${action.glassapi}/webresources/stations/v2/list/files_type`)
        .then(
          (response) => {
            const filetypeResult = response.data;
            const fileType = [];
            filetypeResult.forEach((item) => {
              if (item.sampling_window === '24h' && item.sampling_frequency === '30s') {
                fileType.push({
                  name: `${item.format} - ${item.sampling_window} - ${item.sampling_frequency}`,
                });
              }
            });
            store.dispatch(saveFileTypeList(fileType));
          },
        ).catch(
          () => {
            console.log('no data from API');
          },
        );
      next(action);
      break;
    }
    case FETCH_ADVANCED_SEARCH: {
      axios
        .get(`${action.server}${action.glassapi}/webresources/stations/v2/combination/full/json?${action.query}`)
        .then(
          (response) => {
            if (response.data === 0) {
              store.dispatch(setModalNoData(true));
            }
            else if (response.data.length === 1) {
              window.open(`${window.origin}#/metadata/marker=${response.data[0].marker_long_name}/description`, '_self');
            }
            else {
              store.dispatch(setSaveFullDataSelectedStations(response.data));
            }
          },
        ).catch((error) => {
          if (error.code !== '' || error.code !== undefined) {
            store.dispatch(setModalErrCo(true));
            store.dispatch(setErrorCode(error.code));
            store.dispatch(setErrorStatus(error.request.status));
          }
          console.log('Erreur API:', error, error.response);
        }).finally(() => {
          store.dispatch(setLoadingChart(false));
        });
      next(action);
      break;
    }
    case FETCH_NODE_INFO_MAP_PAGE: {
      axios
        .get(`${action.backend}/backend/data/api/pages/${action.value}/`)
        .then(
          (response) => {
            store.dispatch(setSaveMapNodeInfoPage(response.data));
          },
        ).catch(() => {
          console.log('No response from API');
        }).finally(() => {
          store.dispatch(setLoadingNodeInfoMap(false));
        });
      next(action);
      break;
    }
    case FETCH_NODE_INFO_TAB_PAGE: {
      axios
        .get(`${action.backend}/backend/data/api/pages/${action.value}/`)
        .then(
          (response) => {
            store.dispatch(setSaveTabNodeInfoPage(response.data));
          },
        ).catch(() => {
          console.log('No response from API');
        }).finally(() => {
          store.dispatch(setLoadingNodeInfoTab(false));
        });
      next(action);
      break;
    }
    case FETCH_HEADER: {
      axios
        .get(`${action.backend}/backend/data/api/pages/${action.value}/`)
        .then(
          (response) => {
            store.dispatch(setSaveDataHeader(response.data));
          },
        ).catch(() => {
          console.log('No response from API');
        }).finally(() => {
          store.dispatch(setLoadingHeader(false));
        });
      next(action);
      break;
    }
    case FETCH_FOOTER: {
      axios
        .get(`${action.backend}/backend/data/api/pages/${action.value}/`)
        .then(
          (response) => {
            store.dispatch(setSaveDataFooter(response.data));
          },
        ).catch(() => {
          console.log('No response from API');
        }).finally(() => {
          store.dispatch(setLoadingFooter(false));
        });
      next(action);
      break;
    }
    case FETCH_ALL_PAGES: {
      axios
        .get(`${action.value}/backend/data/api/pages/`)
        .then(
          (response) => {
            store.dispatch(savePagesList(response.data.items));
          },
        ).catch(() => {
          console.log('No response from API');
        }).finally(() => {
          store.dispatch(setLoadingHeader(false));
          store.dispatch(setLoadingFooter(false));
        });
      next(action);
      break;
    }
    case FETCH_PERSONALIZED_PAGE_HTML: {
      axios
        .get(`${action.backend}/backend/data/api/pages/${action.query}/`)
        .then((response) => {
          store.dispatch(savePersonalizedPageHtml(response.data));
          if (response.status === 200) {
            personalized = true;
          }
        }).catch(() => {
          console.log('No response from API');
        }).finally(() => {
          if (personalized) {
            store.dispatch(setLoadingPersonalized(false));
          }
        });
      next(action);
      break;
    }
    case SET_FETCH_DOI_AND_LICENCE: {
      axiosInstanceDGWAPI
        .get(`/api/md_station/stations_info/${action.value}`)
        .then((response) => {
          store.dispatch(DisplayDOI(false));
          store.dispatch(SaveDoiAndLicence(response.data));
        }).catch(() => {
          console.log('No response from API');
        }).finally(() => {
          store.dispatch(DisplayDOI(true));
        });
      next(action);
      break;
    }
    case SET_FETCH_IMAGES: {
      axiosInstanceDGWAPI
        .get(`/api/md_station/images_per_station/${action.value}`)
        .then((response) => {
          store.dispatch(DisplayImages(false));
          store.dispatch(SaveImages(response.data));
          if (response.status === 200) {
            store.dispatch(setResponseImage(true));
          }
        }).catch(() => {
          console.log('No response from API');
          store.dispatch(setResponseImage(false));
        }).finally(() => {
          store.dispatch(DisplayImages(true));
        });
      next(action);
      break;
    }
    case FETCH_BACKEND_POPUP: {
      axios
        .get(`${action.backend}/backend/data/api/pages/${action.query}`)
        .then((response) => {
          store.dispatch(saveBackendPopup(response.data));
        }).catch(() => {
          console.log('No response from API');
        }).finally(() => {
        });
      next(action);
      break;
    }
    default:
      next(action);
  }
};

export default apiMiddleWare;
